module.exports = __webpack_public_path__ + "assets/img/two-images-1.5ef3d3f1.jpg";